import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';

const IconPin = ({ width = 25, height = 24, viewBox = '0 0 25 24', color = colors.mineShaft }) => {
	return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M16.332 13L14.332 10L15.332 4H9.33203L10.332 10L8.33203 13V15H11.462V20H13.332V15H16.332V13Z' fill={color} />
	</svg>;
};

IconPin.propTypes = {
	color: PropTypes.string,
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	viewBox: PropTypes.string,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconPin;
